<script>
import axios from "axios";
import TitlePage from "../components/layout/TitlePage.vue";
import MantenedorEditAgentCredentialsModal from "./mantenedor/components/MantenedorEditAgentCredentialsModal.vue";

export default {
  components: { TitlePage, MantenedorEditAgentCredentialsModal },
  data() {
    return {
      agents: [],
      selectedAgent: undefined,

      historyFields: [
        { key: "created_at", label: "Fecha de cambio" },
        { key: "scrapper", label: "Tipo de scrapper" },
        { key: "agent", label: "Agente" },
        { key: "username", label: "Nombre de usuario" },
        { key: "password", label: "Contraseña" },
      ],
      changeHistory: [],
      changeHistoryMeta: { current_page: 1 },

      fetchAgentsIsSuccess: undefined,
      fetchAgentsIsError: undefined,
      fetchAgentsIsPending: undefined,

      fetchHistoryIsSuccess: undefined,
      fetchHistoryIsError: undefined,
      fetchHistoryIsPending: undefined,

      editModal: false,
    };
  },
  methods: {
    async fetchAgents() {
      this.fetchAgentsIsPending = true;
      try {
        //const { data, status } = await axios.get(`/api/list?get=["agentes"]`);
        const { data, status } = await axios.get(`/api/admin/agentes`);

        if (status == 200 && data?.data) {
          //this.agents = { ...data?.data?.agentes };
          this.agents = {
            ...data?.data?.map((item) => ({
              value: item.id,
              key: `${item.codigo.toUpperCase()} - ${item.nombre}`,
              ultima_credencial: item.ultima_credencial ?? null,
            })),
          };
        }
        this.fetchAgentsIsError = false;
        this.fetchAgentsIsSuccess = true;
      } catch (e) {
        console.error(e);
        this.fetchAgentsIsError = true;
        this.$swal({
          icon: "error",
          title: "¡Error!",
          text: "Hubo un problema para obtener las credenciales actuales",
        });
      }
      this.fetchAgentsIsPending = false;
    },
    async fetchHistory() {
      this.fetchAgentsIsPending = true;

      const query = {
        params: {
          page: this.changeHistoryMeta.current_page,
        },
      };

      try {
        const { data, status } = await axios.get(
          `/api/admin/agentes/historial-credenciales`,
          query
        );

        if (status == 200 && data?.data && data?.meta) {
          this.changeHistory = [...data.data];
          this.changeHistoryMeta = { ...data.meta };
        }
      } catch (e) {
        console.error(e);
        this.fetchHistoryIsError = true;

        this.$swal({
          icon: "error",
          title: "¡Error!",
          text: "Hubo un problema para obtener el historial de cambios credenciales",
        });
        // Fire swal for error.
      }
    },
  },

  mounted() {
    this.fetchAgents();
    this.fetchHistory();
  },
  watch: {
    "changeHistoryMeta.current_page": function () {
      this.fetchHistory();
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-8 text-left">
    <title-page title="Mantenedor de credenciales" />

    <div class="flex flex-col gap-4 shadow-md bg-white p-4">
      <h1 class="!text-xl !font-bold">Mantenedor de credenciales</h1>
      <div class="flex flex-col gap-2">
        <div class="flex flex-row items-center gap-4">
          <fas :icon="['fas', 'info']" />
          <div class="text-md font-semibold">
            Las credenciales se deben actualizar cada 6 meses.
          </div>
        </div>

        <p class="text-sm text-gray-600">
          El sistema utiliza estas credenciales para acceder a comext.aduanas.cl
          para realizar el web-scrapping.
        </p>
      </div>

      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-4">
          <h1 class="!text-lg !font-bold">Agentes</h1>

          <div class="flex flex-col sm:flex-row gap-4">
            <select v-model="selectedAgent">
              <option v-for="agent in agents" :value="agent" :key="agent.value">
                {{ agent.key }}
              </option>
            </select>

            <div class="mt-auto">
              <button
                type="button"
                class="btn-principal w-full sm:w-fit"
                @click="() => (editModal = true)"
                :disabled="!selectedAgent"
              >
                <fas :icon="['fas', 'edit']" />
                Editar credenciales
              </button>

              <mantenedor-edit-agent-credentials-modal
                :visible="editModal"
                :agent="selectedAgent"
                @close-modal="() => (editModal = false)"
                @refetch-history="() => this.fetchHistory()"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <h1 class="!text-lg !font-bold">Historial de cambios</h1>
        <b-table
          striped
          hover
          :items="changeHistory"
          :fields="historyFields"
          show-empty
          responsive
        >
          <template #empty>
            <h1 class="text-center">No hay documentos disponibles</h1>
          </template>

          <template #cell(created_at)="row">
            {{ moment(row.item.created_at).format("DD-MM-YYYY") }}
          </template>

          <template #cell(scrapper)="row">
            {{ row.item?.scrapper_type?.name ?? "-" }}
          </template>
          <template #cell(agent)="row">
            {{ row.item.agente?.nombre ?? "-" }}
          </template>

          <template #cell(username)="row">
            {{ row.item.username ?? "-" }}
          </template>

          <template #cell(password)="row"> ******** </template>
        </b-table>

        <b-pagination
          v-model="changeHistoryMeta.current_page"
          :total-rows="changeHistoryMeta.total"
          :per-page="changeHistoryMeta.per_page"
          align="fill"
          size="sm"
          class="w-12 mx-auto"
        />
      </div>
    </div>
  </div>
</template>
